<script lang="ts">
  export let theme = 'dark';
  export let position = 'top';
  export let rsScroll: number = 0;
  export let description = false;
  export let hide = false;
</script>

<div class="tooltip-container">
  <slot />
  {#if !hide}
    <div
      class={`tooltip ${theme} ${position}`}
      class:description
      style="--scrollY: {rsScroll}px"
    >
      <slot name="tip" />
    </div>
  {/if}
</div>

<style lang="scss">
  @import '../../styles/mixins';

  .tooltip-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    margin-left: auto;
    z-index: 1;

    .tooltip {
      position: fixed;
      opacity: 0;
      transition: all 0.1s ease-out;
      padding: 5px 8px 6px;
      background: var(--color-blue-gray--700);
      box-shadow: 0px 4px 12px rgba(29, 29, 32, 0.08), 0px 1px 2px rgba(29, 29, 32, 0.04);
      border-radius: 5px;
      @include font(Semibold);
      color: var(--color-blue-gray--50);
      font-size: 12px;
      line-height: 16px;
      white-space: nowrap;
      pointer-events: none;
      z-index: 3;

      &.description {
        padding: 12px;
        border-radius: 10px;
      }

      &.top {
        transform: translate(45%, calc(-16px - var(--scrollY)));
      }

      &.right {
        transform: translate(105%, calc(0px - var(--scrollY)));
      }

      &.bottom {
        transform: translate(50%, 80%);
      }

      &.light {
        background: var(--color-bg--lightest);
        box-shadow: 0px 4px 12px rgba(29, 29, 32, 0.08),
          0px 1px 2px rgba(29, 29, 32, 0.04);
        color: var(--color-blue-gray--500);
      }
    }

    &:hover {
      .tooltip {
        opacity: 1;
        transition: all 0.1s ease-in;
        z-index: 4;

        &.top {
          transform: translate(45%, calc(-24px - var(--scrollY)));
        }

        &.right {
          transform: translate(120%, calc(0px - var(--scrollY)));
        }

        &.bottom {
          transform: translate(50%, 110%);
        }
      }
    }
  }
</style>
